import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Button, Divider } from 'base-ui'

import { useProductPageContext } from '../productPageContext'

export const ProductPageOdsDialogButtonsGroup: FC<{
  onlineDoctorServiceLink?: string
}> = ({ onlineDoctorServiceLink }) => {
  const { productPageOdsConfig } = useProductPageContext()

  return (
    <div className="mt-5">
      <Button<'a'>
        className="w-full"
        data-is-home-one
        data-qa-id="form-ods-modal-go-to-zava"
        href={onlineDoctorServiceLink}
        slots={{ root: 'a' }}
      >
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.button.accesstomedication" />
      </Button>

      <Divider className="my-4">
        <FormattedMessage id="general.label.or" />
      </Divider>

      <Button<'a'>
        className="w-full"
        href={productPageOdsConfig?.findStationaryDoctorUrl}
        rel="noopener noreferrer"
        slots={{ root: 'a' }}
        target="_blank"
      >
        <FormattedMessage id="pdp.buyboxwithvariants.odsModal.button.localsearch" />
      </Button>
    </div>
  )
}
